import { isAxiosError } from "axios";

/** Human-readable message from FastAPI / axios error responses. */
export function formatApiErrorDetail(err: unknown): string | null {
  if (!isAxiosError(err)) return null;
  const detail = err.response?.data?.detail;
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => {
        if (typeof item === "object" && item !== null && "msg" in item) {
          const loc = "loc" in item && Array.isArray(item.loc) ? item.loc.join(".") : "";
          return loc ? `${loc}: ${item.msg}` : String((item as { msg: unknown }).msg);
        }
        return String(item);
      })
      .join("; ");
  }
  return String(detail);
}
